import { Component, Output, EventEmitter, Input, OnInit, AfterViewInit, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RktFormFieldConfig, RktFormModule } from '@rocketfinancialcorp/rocket-ui/form';
import { Address, AddressesForm, AddressType, FormModel } from '@shared/models';
import { addressFormFields } from '../address-fields';

@Component({
  selector: 'app-address-add',
  templateUrl: 'address-add.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FormsModule, ReactiveFormsModule, RktFormModule],
})
export class AddressAddComponent implements OnInit, AfterViewInit {
  @Input() type!: AddressType;

  @Input() isRequired?: boolean = false;

  @Output() changed = new EventEmitter<Address[]>();

  @Output() isFormInvalid = new EventEmitter<boolean>();

  addressForm = new FormGroup({});

  formModel: FormModel<AddressesForm> = { addresses: [] };

  addressFields: RktFormFieldConfig[] = [];

  ngOnInit(): void {
    const addressFields = addressFormFields({
      type: this.type,
      onMakePrimaryClick: this.onMakePrimaryClick.bind(this),
      onSectionRemove: this.onSectionRemove.bind(this),
      isRequired: this.isRequired,
    });

    this.formModel = {
      ...this.formModel,
      addresses: [
        ...(this.formModel.addresses ?? []),
        {
          addressLine1: undefined,
          addressLine2: undefined,
          city: undefined,
          state: undefined,
          postalCode: undefined,
          country: undefined,
          primary: this.type === 'PHYSICAL',
          type: this.type,
        },
      ],
    };

    this.addressFields = [...addressFields];
  }

  ngAfterViewInit(): void {
    this.addressForm.markAllAsTouched();
    this.isFormInvalid.emit(!this.addressForm.invalid);
  }

  onMakePrimaryClick(i: number) {
    const addresses = this.formModel.addresses ? [...this.formModel.addresses] : [];
    if (!addresses.length) {
      return;
    }

    addresses[0].primary = false;
    addresses[i].primary = true;
    const newPrimaryAddress = addresses.splice(i, 1)[0];
    addresses.unshift(newPrimaryAddress);
    this.formModel = {
      ...this.formModel,
      addresses: [...addresses],
    };
  }

  onSectionRemove(i: number, removeSection: (index: number) => void) {
    removeSection(i);

    if (!this.formModel.addresses?.length) {
      this.formModel = {
        ...this.formModel,
        addresses: [
          ...(this.formModel.addresses ?? []),
          {
            addressLine1: undefined,
            addressLine2: undefined,
            city: undefined,
            state: undefined,
            postalCode: undefined,
            country: undefined,
            primary: this.type === 'PHYSICAL',
            type: this.type,
          },
        ],
      };
    }
  }

  onFormUpdate(): void {
    const { addresses = [] } = this.formModel;

    if (!addresses.length) {
      return;
    }

    const updatedAddresses = addresses.map((address, index) => ({
      ...address,
      city: address.city?.slice(0, 25),
      state: address.state?.slice(0, 3),
      primary: index === 0,
    }));

    setTimeout(() => {
      this.formModel = { ...this.formModel, addresses: updatedAddresses };

      this.changed.emit(
        updatedAddresses.map((address) => ({
          streetLine1: address.addressLine1!,
          streetLine2: address.addressLine2,
          cityName: address.city!,
          stateCode: address.state!,
          zipCode: address.postalCode!,
          countryCode: address.country!,
          primary: address.primary,
          type: address.type!,
        })),
      );
      this.isFormInvalid.emit(!this.addressForm.invalid);
    }, 0);
  }
}
